import { resourcePopulatorServices } from "./resource-populator";

export const populatorServices = {
  resourcePopulatorServices
};